import { isEqual } from "lodash";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { type TimeSlot } from "../../../../Shift/Open/types";

export interface FiltersFormValues {
  shiftTimeSlots: TimeSlot[];
  licenses: string[];
}

interface UseFiltersFormProps {
  initialValues?: Partial<FiltersFormValues>;
}

const defaultValues: FiltersFormValues = {
  shiftTimeSlots: [],
  licenses: [],
};

export function useFiltersForm(props?: UseFiltersFormProps) {
  const { initialValues = {} } = props ?? {};

  const form = useForm<FiltersFormValues>({
    defaultValues: {
      ...defaultValues,
      ...initialValues,
    },
  });

  const [appliedFilters, setAppliedFilters] = useState<FiltersFormValues>({
    ...defaultValues,
    ...initialValues,
  });

  const changedFiltersCount = Object.entries(appliedFilters).filter(
    ([key, value]) => !isEqual(value, defaultValues[key as keyof FiltersFormValues])
  ).length;

  const resetFilters = () => {
    form.reset(defaultValues);
    setAppliedFilters(defaultValues);
  };

  const cancelFilters = () => {
    form.reset();
  };

  const submitFilters = () => {
    const newFilters = form.getValues();
    setAppliedFilters(newFilters);
  };

  return { form, changedFiltersCount, resetFilters, cancelFilters, submitFilters, appliedFilters };
}
